import { render, staticRenderFns } from "./SecurityGdpr.vue?vue&type=template&id=6195a18e&scoped=true&"
import script from "./SecurityGdpr.vue?vue&type=script&lang=js&"
export * from "./SecurityGdpr.vue?vue&type=script&lang=js&"
import style0 from "./SecurityGdpr.vue?vue&type=style&index=0&id=6195a18e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6195a18e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
